import React from 'react';
import './StatCards.css';

var Icon = function (props) {
  var name = props.name;
  var paths = {
    grid: [
      React.createElement('rect', { key: 'a', x: 3, y: 3, width: 7, height: 7, rx: 1 }),
      React.createElement('rect', { key: 'b', x: 14, y: 3, width: 7, height: 7, rx: 1 }),
      React.createElement('rect', { key: 'c', x: 3, y: 14, width: 7, height: 7, rx: 1 }),
      React.createElement('rect', { key: 'd', x: 14, y: 14, width: 7, height: 7, rx: 1 }),
    ],
    check: [React.createElement('path', { key: 'a', d: 'M20 6 9 17l-5-5' })],
    pause: [
      React.createElement('path', { key: 'a', d: 'M8 5v14' }),
      React.createElement('path', { key: 'b', d: 'M16 5v14' }),
    ],
    lock: [
      React.createElement('rect', { key: 'a', x: 3, y: 11, width: 18, height: 11, rx: 2 }),
      React.createElement('path', { key: 'b', d: 'M7 11V7a5 5 0 0 1 10 0v4' }),
    ],
    layers: [
      React.createElement('path', { key: 'a', d: 'm12 3 9 5-9 5-9-5 9-5Z' }),
      React.createElement('path', { key: 'b', d: 'm3 12 9 5 9-5' }),
      React.createElement('path', { key: 'c', d: 'm3 16 9 5 9-5' }),
    ],
    box: [
      React.createElement('path', { key: 'a', d: 'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z' }),
      React.createElement('path', { key: 'b', d: 'm3.3 7 8.7 5 8.7-5' }),
      React.createElement('path', { key: 'c', d: 'M12 22V12' }),
    ],
    alert: [
      React.createElement('path', { key: 'a', d: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z' }),
      React.createElement('path', { key: 'b', d: 'M12 9v4' }),
      React.createElement('path', { key: 'c', d: 'M12 17h.01' }),
    ],
    cart: [
      React.createElement('circle', { key: 'a', cx: 8, cy: 21, r: 1 }),
      React.createElement('circle', { key: 'b', cx: 19, cy: 21, r: 1 }),
      React.createElement('path', { key: 'c', d: 'M2.1 2.1h2l2.7 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L21 7H5.1' }),
    ],
    users: [
      React.createElement('path', { key: 'a', d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' }),
      React.createElement('circle', { key: 'b', cx: 9, cy: 7, r: 4 }),
      React.createElement('path', { key: 'c', d: 'M22 21v-2a4 4 0 0 0-3-3.9' }),
      React.createElement('path', { key: 'd', d: 'M16 3.1a4 4 0 0 1 0 7.8' }),
    ],
    message: [
      React.createElement('path', { key: 'a', d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z' }),
    ],
    credit: [
      React.createElement('rect', { key: 'a', x: 2, y: 5, width: 20, height: 14, rx: 2 }),
      React.createElement('path', { key: 'b', d: 'M2 10h20' }),
    ],
    star: [
      React.createElement('path', { key: 'a', d: 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8-6.2-3.2L5.8 21 7 14.2 2 9.3l6.9-1Z' }),
    ],
    calendar: [
      React.createElement('path', { key: 'a', d: 'M8 2v4' }),
      React.createElement('path', { key: 'b', d: 'M16 2v4' }),
      React.createElement('rect', { key: 'c', x: 3, y: 4, width: 18, height: 18, rx: 2 }),
      React.createElement('path', { key: 'd', d: 'M3 10h18' }),
    ],
    clock: [
      React.createElement('circle', { key: 'a', cx: 12, cy: 12, r: 9 }),
      React.createElement('path', { key: 'b', d: 'M12 7v5l3 2' }),
    ],
  };

  return React.createElement('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  }, paths[name] || paths.grid);
};

var StatCard = function (props) {
  var card = props.card || {};
  var clickable = typeof card.onClick === 'function';
  return React.createElement('div', {
    className: 'admin-stat-card' + (clickable ? ' admin-stat-card-clickable' : '') + (card.active ? ' admin-stat-card-active' : ''),
    style: card.accent ? { '--stat-accent': card.accent } : undefined,
    role: clickable ? 'button' : undefined,
    tabIndex: clickable ? 0 : undefined,
    onClick: card.onClick,
    onKeyDown: function (event) {
      if (!clickable) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        card.onClick();
      }
    },
  },
    React.createElement('div', { className: 'admin-stat-main' },
      React.createElement('div', { className: 'admin-stat-icon' }, React.createElement(Icon, { name: card.icon })),
      React.createElement('div', { className: 'admin-stat-copy' },
        React.createElement('div', { className: 'admin-stat-value' }, card.value),
        React.createElement('div', { className: 'admin-stat-title' }, card.title),
        card.description && React.createElement('div', { className: 'admin-stat-desc' }, card.description)
      )
    ),
    React.createElement('div', { className: 'admin-stat-bg-icon' }, React.createElement(Icon, { name: card.icon }))
  );
};

var StatCards = function (props) {
  var cards = props.cards || [];
  var count = cards.length;
  return React.createElement('div', {
    className: 'admin-stat-grid' + (count ? ' admin-stat-grid-' + count : ''),
    'data-count': count,
    style: count > 0 && count < 4 ? { gridTemplateColumns: 'repeat(' + count + ', minmax(0, 1fr))' } : undefined
  },
    cards.map(function (card, index) {
      return React.createElement(StatCard, { key: card.title || index, card: card });
    })
  );
};

export default StatCards;
